import React, { useContext } from 'react'
import styled from 'styled-components'
import {
  borderRadius,
  borderRadiusSizes,
  colors,
  marginSizes,
  paddingSizes
} from '@jarvis.oddle/core/theme/default'
import Div from '@jarvis.oddle/core/components/Div'
import { P } from '@jarvis.oddle/core/components/Typo'
import ProgressBar from '@jarvis.oddle/core/components/ProgressBar'
import { analyseStoreOrder } from 'src/utils/order'
import { useAppContext } from 'src/containers/AppContext'
import StoreOrderContext from 'src/containers/StoreOrder'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'

const ProgressBarContainer = styled(Div).attrs(() => ({
  padding: paddingSizes.small
}))`
  background-color: ${colors.background};
  border-radius: ${borderRadius[borderRadiusSizes.medium]};
`

const ProgressBarText = styled(P).attrs(() => ({
  marginTop: marginSizes.extraSmall,
  marginBottom: marginSizes.extraSmall
}))`
  color: ${colors.heading};
`

const Seperator = styled.div`
  height: 10px;
`
const CartProgressBars = React.memo((): JSX.Element => {
  const { t } = useContext(TranslationContext)
  const storeOrder = useContext(StoreOrderContext).storeOrder.data
  const { formatMoney } = useAppContext()

  const {
    hasMinimumOrder,
    hasDeliveryFee,
    hasFreeDelivery,
    reachedMinOrder,
    reachedFreeDelivery,
    amountToMinOrder,
    amountToFreeDelivery
  } = React.useMemo(() => analyseStoreOrder(storeOrder), [storeOrder])

  return hasMinimumOrder || (hasDeliveryFee && hasFreeDelivery) ? (
    <Div padding={paddingSizes.small}>
      <ProgressBarContainer>
        {hasMinimumOrder && (
          <React.Fragment>
            <ProgressBarText>
              {reachedMinOrder
                ? t(`Hurray! You've hit the min order of _min_`, {
                    min: formatMoney(storeOrder.minimumOrder)
                  })
                : t('_amount_ more to min order of _min_', {
                    amount: formatMoney(amountToMinOrder),
                    min: formatMoney(storeOrder.minimumOrder)
                  })}
            </ProgressBarText>
            <ProgressBar
              percent={
                (storeOrder.subtotal / storeOrder.minimumOrder) * 100
              }
            />
          </React.Fragment>
        )}
        {hasMinimumOrder && hasDeliveryFee && hasFreeDelivery && <Seperator />}
        {hasDeliveryFee && hasFreeDelivery && (
          <React.Fragment>
            <ProgressBarText>
              {reachedFreeDelivery
                ? t(`Hurray! You've hit the free delivery amount`)
                : t('_amount_ more to free delivery', {
                    amount: formatMoney(amountToFreeDelivery)
                  })}
            </ProgressBarText>
            <ProgressBar
              percent={
                ((storeOrder.deliveryFreeAfter - amountToFreeDelivery) /
                  storeOrder.deliveryFreeAfter) *
                100
              }
            />
          </React.Fragment>
        )}
      </ProgressBarContainer>
    </Div>
  ) : null
})

export default CartProgressBars
